import React, { Component } from 'react';
import AssignedUserCard from './Assigned/AssignedUserCard';
import ReactSelectAsyncContainer from '../../reactSelectWrappers/ReactSelectAsyncContainer';

class PMAssignmentSection extends Component {
	render() {
		const p = this.props;
		return (
			<div className={"PMAssignmentSection"}>
				{this.header()}
				<div className={"PMAssignmentList"}>
					{p.users !== undefined ? this.list() : null}
				</div>
				<span>Add</span>
				<ReactSelectAsyncContainer
					queryName={'PM.AssignableUserSearch'}
					attr={'Phrase'}
					typeName={'Phrase'}
					focus={true}
					querySearch={false}
					minimumAttributeLength={2}
					onChange={p.addAssigned}
					returnObj={{ attr: 'uniqueID' }}
				/>
			</div>
		);
	}

	header = () => {
		const p = this.props;
		return (
			<div> <h3>{p.header}</h3></div>
		)
	}

	list = () => {
		const p = this.props;

		return p.users.map((user, index) => {
			return <AssignedUserCard
				key={user + "_" + index}
				user={user}
				removeAssigned={p.removeAssigned}
			/>
		})
	}
}

export default PMAssignmentSection;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/PMAssignmentSection.js